<template>
  <header id="myHeader" class="l-primary-bg">
    <div class="top-baar primary-bg pt-2 pb-2">
      <div class="container">
        <div class="row">
          <div class="top-baar-inner align-items-center p-0">
            <div class="d-flex align-items-center gap-3">
              <div class="social">
                <ul class="d-flex gap-2">
                  <li>
                    <a
                      rel="nofollow"
                      target="_blank"
                      href="https://www.linkedin.com/company/75156121/admin/"
                      class="d-flex justify-content-center align-items-center bg-white primary-color"
                      aria-label="linkedin"
                      ><i class="fa fa-linkedin" aria-hidden="true"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      rel="nofollow"
                      target="_blank"
                      href="https://www.instagram.com/culturecity.explore/"
                      class="d-flex justify-content-center align-items-center bg-white primary-color"
                      aria-label="instagram"
                      ><i class="fa fa-instagram" aria-hidden="true"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      rel="nofollow"
                      target="_blank"
                      href="https://www.facebook.com/cultureinyourcity/"
                      class="d-flex justify-content-center align-items-center bg-white primary-color"
                      aria-label="facebook"
                      ><i class="fa fa-facebook" aria-hidden="true"></i
                    ></a>
                  </li>
                  <!-- <li>
                    <a
                      rel="nofollow"
                      target="_blank"
                      href="https://twitter.com/theethnicevents"
                      class="d-flex justify-content-center align-items-center bg-white primary-color"
                      aria-label="twitter"
                      ><i class="fa fa-twitter" aria-hidden="true"></i
                    ></a>
                  </li> -->
                </ul>
              </div>
              <p class="ambassador">
                <!-- <router-link
                  class="text-white d-flex align-items-center top-h-btn text-decoration-underline"
                  :to="{ name: ROUTES.BECOMEAMBASSADOR }"
                >
                  Become an Ambassador
                </router-link> -->
                <!-- <router-link
                  class="text-white d-flex align-items-center top-h-btn text-decoration-underline"
                  :to="{ name: ROUTES.REQUEST_PRIVATE_EVENT }"
                >
                  Request a Private Event
                </router-link> -->
                <p  class="text-white d-flex align-items-center top-h-btn">Discover Culture.  Connect Communities.  Experience Your City.</p>
              </p>
            </div>

            <!-- <div class="top-baar-center">
              <button
                @click="openJoinNewsLetterModal"
                class="d-flex top-bar-join-newsletter"
                aria-label="Subscribe to our newsletter"
              >
                <i class="fa fa-envelope m-0" aria-hidden="true"></i> Join Our
                Newsletter
              </button>
            </div> -->
            <div class="top-baar-btn">
              <div
                class="top-btn d-flex gap-2 d-flex align-items-center justify-content-center flex-wrap"
              >
                <span
                  v-if="!isMobile"
                  class="text-white d-flex align-items-center"
                  >Download Our App</span>
                <span v-if="!isMobile">
                  <a
                    rel="nofollow"
                    target="_blank"
                    href="https://play.google.com/store/apps/details?id=com.culturecity.app"
                  >
                    <img :src="googleApp" alt="img" />
                  </a>
                </span>
                <span v-if="!isMobile">
                  <a
                    rel="nofollow"
                    target="_blank"
                    href="https://apps.apple.com/app/id1606290365"
                  >
                    <img :src="appStore" alt="img" />
                  </a>
                </span>
                <!--
                                    <span  v-if="isMobile && isIOS">
                                        <a href="javascript:;" @click="openInApp" class="primary-bg text-white pt-2 pb-2 ps-2 pe-2 d-inline-block o-i-a">Open In App</a>
                                    </span> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="header-section pt-3 pb-3 l-primary-bg">
      <div class="container">
        <div class="row">
          <nav class="navbar navbar-expand-lg justify-content-between">
            <div class="logo">
              <router-link :to="{ name: ROUTES.HOME }" class="navbar-brand">
                <img :src="logo" alt="Culture City" />
              </router-link>
            </div>
            <button
              class="navbar-toggler"
              type="button"
              @click="showHideMenuBar"
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span class="t-baar">
                <span class="navbar-toggler-icons"></span>
                <span class="navbar-toggler-icons"></span>
                <span class="navbar-toggler-icons"></span>
              </span>
            </button>
            <div id="menu-bar-div" class="menu d-flex gap-3 align-items-center">
              <HomeMenuList />
            </div>
          </nav>
        </div>
      </div>
    </div>
  </header>
  <join-news-letter-modal
    @handle-close-modal="openJoinNewsLetterModal"
    :modal-active="isOpenJoinNewsLetterModal"
    :toggle-modal="openJoinNewsLetterModal"
  />
</template>

<script setup>
import { ref, onMounted, defineProps, watch } from "vue";
import googleApp from "@/assets/header/google-app.svg";
import appStore from "@/assets/header/app-store.svg";
import logo from "@/assets/header/logo.svg";
import search from "@/assets/header/search.svg";
import TopBarSearchForm from "@/components/stateful/home/top-bar-search-form";
import HomeMenuList from "@/components/presentational/home/home-menu-list";
import { ROUTES } from "@/utils/constants/routes";
import { useRoute } from "vue-router";
import JoinNewsLetterModal from "@/components/presentational/news-letter/modals/join-news-letter-modal";

const isMobile =
  /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent,
  );
const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);

const openInApp = () => {
  // Attempt to open the app using the custom URI scheme

  const appURI = isIOS ? "culturecity://" : "culturecity://open";

  window.location.href = appURI;

  // Set a timeout to redirect to the app store if the app is not installed
  setTimeout(() => {
    if (isIOS) {
      window.location.href = "https://apps.apple.com/app/id1606290365"; // Replace 'yourapp' with your app's iOS App Store link
    } else {
      window.location.href =
        "https://play.google.com/store/apps/details?id=com.culturecity.app";
    }
  }, 2000); // Change the timeout as per your preference
};

const isOpenJoinNewsLetterModal = ref(false);
const openJoinNewsLetterModal = () => {
  window.scrollTo(0, 0);
  isOpenJoinNewsLetterModal.value = !isOpenJoinNewsLetterModal.value;
  document.getElementById("body").classList.add("modalOpened");
};

const route = useRoute();

watch(
  () => route.path,
  (newPath, oldPath) => {
    // The callback is called when route.path changes

    var collapse = document
      .getElementById("menu-bar-div")
      ?.querySelector(".navbar-collapse");
    if (collapse?.classList.contains("show")) {
      collapse.classList.remove("show");
    }
  },
);

const showHideMenuBar = () => {
  var collapse = document
    .getElementById("menu-bar-div")
    ?.querySelector(".navbar-collapse");
  if (!collapse) return;
  if (collapse.classList.contains("show")) {
    collapse.classList.remove("show");
  } else {
    collapse.classList.add("show");
  }
};
</script>

<script>
export default {
  mounted() {
    // window.onscroll = function() {myFunction()};
    // var header = document.getElementById("myHeader");
    // var sticky = header.offsetTop;
    // function myFunction() {
    //     if (window.pageYOffset > sticky) {
    //         header.classList.add("sticky");
    //     } else {
    //         header.classList.remove("sticky");
    //     }
    // }
  },
};
</script>
<style>
.top-baar-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.ambassador a {
  font-size: 14px;
  width: auto !important;
}

.ambassador a:hover {
  background-color: transparent !important;
}

/* .top-baar-inner .social {
    flex: 1;
}

.top-baar-center {
    flex-shrink: 0;
} */

.top-baar-inner .top-baar-btn {
  /* flex: 1; */
  display: flex;
  justify-content: flex-end;
}

#myHeader {
  position: sticky;
  top: 0;
  z-index: 1000;
}

.top-bar-join-newsletter {
  font-size: 14px;
  font-weight: 600;
  white-space: nowrap;
  background: white;
  border-radius: 10px;
  padding: 7px 16px;
  gap: 6px;
  text-align: center;
  cursor: pointer;
  color: #f05537;
  height: auto;
  border: none;
  font-family: inherit;
  transition: all 0.5s;
}

.top-bar-join-newsletter:hover {
  background: #14163c;
  color: white;
}

.top-bar-join-newsletter i {
  margin-top: -1px !important;
}

@media (max-width: 767px) {
  .top-baar-inner {
    flex-wrap: wrap;
    justify-content: center;
    gap: 8px;
  }

  .top-baar-inner > div:first-child {
    width: 100%;
    justify-content: center;
  }

  .top-baar-center {
    width: 100%;
    display: flex;
    justify-content: center;
  }

  .top-baar-inner .top-baar-btn {
    width: 100%;
    justify-content: center;
  }

  .ambassador a {
    font-size: 12px;
  }

  .top-bar-join-newsletter {
    font-size: 12px;
    padding: 6px 12px;
  }
}
</style>
